import { createContext, useContext, type ReactNode } from 'react'

export type JobWorkspaceMode = 'employer' | 'recruiter'

export type JobWorkspaceScopeValue = {
  mode: JobWorkspaceMode
  /** `/employer/jobs` or `/recruiter/jobs` */
  basePath: string
  listPath: string
}

export const employerJobWorkspaceScope: JobWorkspaceScopeValue = {
  mode: 'employer',
  basePath: '/employer/jobs',
  listPath: '/employer/jobs',
}

export const recruiterJobWorkspaceScope: JobWorkspaceScopeValue = {
  mode: 'recruiter',
  basePath: '/recruiter/jobs',
  listPath: '/recruiter/jobs',
}

const JobWorkspaceScopeContext = createContext<JobWorkspaceScopeValue>(employerJobWorkspaceScope)

export function JobWorkspaceScopeProvider({
  value,
  children,
}: {
  value: JobWorkspaceScopeValue
  children: ReactNode
}) {
  return <JobWorkspaceScopeContext.Provider value={value}>{children}</JobWorkspaceScopeContext.Provider>
}

export function useJobWorkspaceScope() {
  return useContext(JobWorkspaceScopeContext)
}
